var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getArray } from './qbo-json.js';
import { QboFormElement, getApiService } from './Program.js';
/**
  * Renders a <select> element with options populated from a JSON array.
  *
  * @remarks
  * This element is a thin wrapper around {@link QboFetch} that renders a <select> element with options populated from a JSON array.
  */
let QboSelect = class QboSelect extends QboFormElement {
    constructor() {
        super(...arguments);
        this.apiEndpoint = 'default';
        this.loading = false;
        this.optionText = null;
        this.optionValue = null;
        this.defaultValue = null;
        this.emptyOptionText = '--';
        this.emptyOptionValue = '';
        this.options = [];
        this.jsonData = {};
        this.renderInHost = true;
    }
    static { this.styles = [
        css `
            /* Add any custom styles here */
            .foo { color: red; }
        `
    ]; }
    async connectedCallback() {
        this.optionText ??= this.optionValue;
        super.connectedCallback();
        if (this.jsonData !== null) {
            const service = getApiService(this.apiEndpoint);
            this.jsonData = await service.fetch(null, {});
        }
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    render() {
        this.options = getArray(this.jsonData);
        if (!this.options)
            return html `<select ?disabled=${this.hasAttribute('disabled')} class=${this.getAttribute('class')}></select>`;
        this.optionValue ??= Object.keys(this.options[0])[0];
        this.optionText ??= Object.keys(this.options[0])[1] ?? this.optionValue;
        return html `<select ?disabled=${this.hasAttribute('disabled')} class=${this.getAttribute('class')}>
            <option value="${this.emptyOptionValue}">${this.emptyOptionText}</option>
            ${this.options.map(option => html `<option value="${option[this.optionValue]}" ?selected="${option[this.optionValue] == this.defaultValue}">${option[this.optionText]}</option>`)}
        </select>`;
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelect.prototype, "apiEndpoint", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboSelect.prototype, "loading", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelect.prototype, "optionText", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelect.prototype, "optionValue", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelect.prototype, "defaultValue", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelect.prototype, "emptyOptionText", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboSelect.prototype, "emptyOptionValue", void 0);
__decorate([
    property({ type: Array }),
    __metadata("design:type", Object)
], QboSelect.prototype, "options", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboSelect.prototype, "jsonData", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboSelect.prototype, "renderInHost", void 0);
QboSelect = __decorate([
    customElement('qbo-select')
], QboSelect);
export { QboSelect };
